export type WRMResources = { css: string; js: string; preloaded: boolean };

export class WRMResourceRecorder {
	protected css = '';
	protected js = '';
	protected preloaded = false;

	reset(): void {
		this.css = '';
		this.js = '';
		this.preloaded = false;
	}

	setPreloaded(preloaded: boolean): void {
		this.preloaded = preloaded;
	}

	setResources(resources: Omit<WRMResources, 'preloaded'>): void {
		this.css = resources.css ?? '';
		this.js = resources.js ?? '';
		this.preloaded = true;
	}

	getResources(): WRMResources {
		return { css: this.css, js: this.js, preloaded: this.preloaded };
	}
}
